import React, { useCallback, useContext } from "react";
import {
    IColors,
    ITypography,
    ISpacing,
} from "@swiggy-private/dls-web-common/dist/components/types";
import { isApp, ScrolledStateContext } from "@swiggy-private/portal-dineout-context";
import { Container, Separator, StyledAnchor } from "./styles";
import { TEXTS } from "../../constants";

export interface TermsAndConditionLinksProps {
    separator?: string;
    variant?: keyof ITypography;
    color?: keyof IColors;
    link1Text?: string;
    link1Url?: string;
    link2Text?: string;
    link2Url?: string;
    separatorText?: string;
    anchorColor?: keyof IColors;
    anchorTextDecorationColor?: keyof IColors;
    inline?: boolean;
    gap?: keyof ISpacing;
}

const TermsAndConditionLinks = ({
    separator = "•",
    variant = "V2.overline.neutral.bold",
    color = "text_Med_Emphasis",
    link1Text = TEXTS.TERMS_AND_CONDITIONS,
    link1Url = "https://www.swiggy.com/terms-and-conditions",
    link2Text = TEXTS.PRIVACY_POLICY,
    link2Url = "https://www.swiggy.com/privacy-policy",
    separatorText,
    anchorColor,
    anchorTextDecorationColor,
    inline = false,
    gap = "xSmall",
}: TermsAndConditionLinksProps) => {
    const displaySeparator = separatorText !== undefined ? separatorText : separator;
    const { sdk } = useContext(ScrolledStateContext);

    const handleLinkClick = useCallback(
        (e: React.MouseEvent<HTMLAnchorElement>, url: string) => {
            if (isApp()) {
                e.preventDefault();
                if (sdk?.webNavigate) {
                    sdk.webNavigate({
                        url,
                        openAsExternal: true,
                        showBack: true,
                        showLoader: true,
                        callbackUrl: window.location.href,
                        title: "",
                    });
                } else {
                    // Fallback: open in new window if webNavigate is not available
                    window.open(url, "_blank", "noopener,noreferrer");
                }
            }
            // For web, let the default anchor behavior handle the navigation
        },
        [sdk]
    );

    return (
        <Container variant={variant} color={color} $inline={inline} $gap={gap}>
            <StyledAnchor
                target="_blank"
                rel="noopener noreferrer"
                href={link1Url}
                $anchorColor={anchorColor}
                $anchorTextDecorationColor={anchorTextDecorationColor}
                onClick={(e) => handleLinkClick(e, link1Url)}
            >
                {link1Text}
            </StyledAnchor>
            <Separator>{displaySeparator}</Separator>
            <StyledAnchor
                target="_blank"
                rel="noopener noreferrer"
                href={link2Url}
                $anchorColor={anchorColor}
                $anchorTextDecorationColor={anchorTextDecorationColor}
                onClick={(e) => handleLinkClick(e, link2Url)}
            >
                {link2Text}
            </StyledAnchor>
        </Container>
    );
};

export default TermsAndConditionLinks;
